var styles = {"messages":"styles_messages__1ONeU flex flex-column","message":"styles_message__2jcT7 p2 relative","title":"styles_title__2Ya3T mb2","text":"styles_text__3g7F3"};

export default styles;
//# sourceMappingURL=styles.css.js.map
